const getModuleState = (state) => state.sessions;

export const getAllSessions = (state) => getModuleState(state).allSessions;